export const getNextCommentIdForRef = (comments, ref, selectedCommentId = null) => {
    if (!ref || !Array.isArray(comments)) return null;

    const seenIds = new Set();
    const commentIds = comments.reduce((ids, comment) => {
        if (String(comment?.ref || '') !== String(ref) || comment?.id == null) {
            return ids;
        }

        const normalizedId = String(comment.id);
        if (seenIds.has(normalizedId)) return ids;

        seenIds.add(normalizedId);
        ids.push(comment.id);
        return ids;
    }, []);

    if (commentIds.length === 0) return null;

    const currentIndex = commentIds.findIndex((id) => String(id) === String(selectedCommentId));
    return commentIds[(currentIndex + 1) % commentIds.length];
};
